import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

/**
 * This class contains the services for Place / Google. The constructor requires a context to be passed.
 * When using the Place Class, it will require a context to be passed. The context contains the
 * http object, which is specific for each environment
 */
var Place = function Place(context) {
  var _this = this;

  _classCallCheck(this, Place);

  _defineProperty(this, "autocomplete", function (text) {
    return _this.context.http.get("/msvc/v1/places/suggestions?input=".concat(text));
  });

  _defineProperty(this, "get", function (id) {
    return _this.context.http.get("/msvc/v1/places/items/".concat(id));
  });

  _defineProperty(this, "getTimezones", function () {
    return _this.context.http.get('/msvc/v1/places/timezones');
  });

  this.context = context;
};

export default Place;